module.exports = __webpack_public_path__ + "img/trip_sendai16.edc9e142.jpg";